import styled from 'styled-components'

export const ManageReviewerLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
  padding-left: 15px;
`

export const ManageReviewerSeparator = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin: 4px 16px 0 16px;
  width: 1px;
  height: 24px;
  background: rgba(32, 32, 32, 0.1);
`

export const ManageReviewerAvatar = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: -15px;
  background: #e9e9e9;
  background-color: ${(p) => {
    return p.backgroundColor ? p.backgroundColor : '#E9E9E9'
  }};
  border: 2px solid #ffffff;
  width: 32px;
  height: 32px;
  border-radius: 50%;

  > p {
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    letter-spacing: -0.4px;
    color: #ffffff;
    adding-left: 9px;
    margin-top: 10px;
  }
`

export const ReviewerAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  background: #e9e9e9;
  height: 32px;
  border-radius: 50%;

  > p {
    position: absolute;
    width: 100%;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: white;
    padding-left: 9px;
    margin-top: 10px;
  }
`

export const ManageReviewerDropdownItem = styled.div`
  height: 32px;
  display: flex; 
  width: 100%;
  justify-content: space-between;
`

export const ManageReviewerWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ManageAvatar = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
`
export const ManageReviewerName = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 16px;
`

export const ReviewerName = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
`

export const ReviewerEmail = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.5);
`
